import { render } from "./FileSelect.vue?vue&type=template&id=d9682104"
import script from "./FileSelect.vue?vue&type=script&lang=js"
export * from "./FileSelect.vue?vue&type=script&lang=js"
script.render = render

export default script